import { createApi } from "@reduxjs/toolkit/query/react";
import { State } from "@shared/models/State";
import { PaginatedResponse } from "@shared/interfaces";
import { LeadSessionTracking, PayPerLead } from "@shared/models/PayPerLead";
import { axiosBaseQuery } from "@shared/utils/request";
import { showProgress, showLoader } from "@shared/utils";

import config from "../../../config";

export type GetStateListResponse = {
  total: number;
  items: State[];
};

export type GetRejectedLeadsListParams = {
  page?: number;
  limit?: number;
};

export type GetIncompleteLeadsListParams = {
  page?: number;
  limit?: number;
  state?: string;
  county?: string;
};

export type GetLeadSessionListParams = {
  status: string;
  page?: number;
  limit?: number;
  state?: string;
  county?: string;
};

export type GetLeadSessionItemParams = {
  sessionId: string;
};

export type ExportLeadSessionListParams = {
  id: string[] | number[];
};

export const leadSessionApi = createApi({
  reducerPath: "leadSessionApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  tagTypes: ["LeadRejectedList", "LeadsList", "LeadIncompleteList"],
  endpoints: (builder) => ({
    getLeadSessionItem: builder.query<LeadSessionTracking, GetLeadSessionItemParams>({
      query: (params) => {
        return {
          url: `leads/sessions/${params.sessionId}`,
        };
      },
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        showLoader(dispatch, queryFulfilled);
      },
    }),
    getLeadSessionList: builder.query<PaginatedResponse<PayPerLead & LeadSessionTracking>, GetLeadSessionListParams>({
      query: (params) => {
        return {
          url: "leads/sessions",
          params,
        };
      },
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        showProgress(dispatch, queryFulfilled);
      },
    }),
    exportLeadSessionList: builder.mutation<Blob, ExportLeadSessionListParams>({
      query: (body) => {
        return {
          url: "leads/sessions/export",
          method: "POST",
          body,
          responseType: "blob",
        };
      },
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        showProgress(dispatch, queryFulfilled);
      },
    }),
  }),
});

export const { useGetLeadSessionListQuery, useExportLeadSessionListMutation, useGetLeadSessionItemQuery } =
  leadSessionApi;
